var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "27px",
    viewBox: "0 0 24 27",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "pdf") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artefatos",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "artefatos/arquivos",
    transform: "translate(-40.000000, -167.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Acorde\\xE3o",
    transform: "translate(24.000000, 149.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pdf",
    transform: "translate(16.000000, 18.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.06976744,0 C4.12325581,0 3.34883721,0.753488372 3.34883721,1.6744186 L3.34883721,25.1162791 C3.34883721,26.0372093 4.12325581,26.7906977 5.06976744,26.7906977 L22.2790698,26.7906977 C23.2255814,26.7906977 24,26.0372093 24,25.1162791 L24,6.69767442 L17.1162791,0 L5.06976744,0 Z",
    id: "Path",
    fill: "#E2E5E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9767442,6.69767442 L24,6.69767442 L17.3023256,0 L17.3023256,5.02325581 C17.3023256,5.94418605 18.055814,6.69767442 18.9767442,6.69767442 Z",
    id: "Path",
    fill: "#B0B7BD"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#CAD1D8",
    points: "24 11.7209302 18.9767442 6.69767442 24 6.69767442"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6511628,22.6046512 C20.6511628,23.0651163 20.2639535,23.4418605 19.7906977,23.4418605 L0.860465116,23.4418605 C0.387209302,23.4418605 0,23.0651163 0,22.6046512 L0,14.2325581 C0,13.772093 0.387209302,13.3953488 0.860465116,13.3953488 L19.7906977,13.3953488 C20.2639535,13.3953488 20.6511628,13.772093 20.6511628,14.2325581 L20.6511628,22.6046512 Z",
    id: "Path",
    fill: "#F15642"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(3.906977, 15.627907)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.0398645581,0.478883721 C0.0398645581,0.257860465 0.218183442,0.016744186 0.505379721,0.016744186 L2.08881712,0.016744186 C2.98041153,0.016744186 3.78284651,0.59944186 3.78284651,1.71627907 C3.78284651,2.77451163 2.98041153,3.36390698 2.08881712,3.36390698 L0.944318512,3.36390698 L0.944318512,4.248 C0.944318512,4.54269767 0.752282791,4.70930233 0.505379721,4.70930233 C0.279051907,4.70930233 0.0398645581,4.54269767 0.0398645581,4.248 L0.0398645581,0.478883721 L0.0398645581,0.478883721 Z M0.944318512,0.859813953 L0.944318512,2.52753488 L2.08881712,2.52753488 C2.54833116,2.52753488 2.91182735,2.13153488 2.91182735,1.71627907 C2.91182735,1.24827907 2.54833116,0.859813953 2.08881712,0.859813953 L0.944318512,0.859813953 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.12538195,4.70930233 C4.89905414,4.70930233 4.65215107,4.58874419 4.65215107,4.29488372 L4.65215107,0.49227907 C4.65215107,0.252 4.89905414,0.0770232558 5.12538195,0.0770232558 L6.69510251,0.0770232558 C9.82768521,0.0770232558 9.75910102,4.70930233 6.75682828,4.70930233 L5.12538195,4.70930233 L5.12538195,4.70930233 Z M5.55746233,0.894139535 L5.55746233,3.89302326 L6.69510251,3.89302326 C8.54601823,3.89302326 8.62831926,0.894139535 6.69510251,0.894139535 L5.55746233,0.894139535 L5.55746233,0.894139535 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8701648,0.94772093 L10.8701648,2.01181395 L12.6182043,2.01181395 C12.8651073,2.01181395 13.1120104,2.25293023 13.1120104,2.48651163 C13.1120104,2.70753488 12.8651073,2.88837209 12.6182043,2.88837209 L10.8701648,2.88837209 L10.8701648,4.29404651 C10.8701648,4.52846512 10.6995617,4.70846512 10.459517,4.70846512 C10.1577466,4.70846512 9.9734266,4.52846512 9.9734266,4.29404651 L9.9734266,0.49144186 C9.9734266,0.251162791 10.1586039,0.0761860465 10.459517,0.0761860465 L12.8659647,0.0761860465 C13.1677351,0.0761860465 13.346054,0.251162791 13.346054,0.49144186 C13.346054,0.705767442 13.1677351,0.946883721 12.8659647,0.946883721 L10.8701648,0.946883721 L10.8701648,0.94772093 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19.7860465,23.1627907 L3.34883721,23.1627907 L3.34883721,24 L19.7860465,24 C20.2618605,24 20.6511628,23.6232558 20.6511628,23.1627907 L20.6511628,22.3255814 C20.6511628,22.7860465 20.2618605,23.1627907 19.7860465,23.1627907 Z",
    id: "Path",
    fill: "#CAD1D8"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.c81182737badd3a774a832adb977d7f1.svg";
export { ForwardRef as ReactComponent };